import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, FormControlLabel } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Checkbox } from 'src/Libs/inputs/formik'
import ReactMarkdown from 'react-markdown'
import { useCookies } from 'src/Libs/cookies'
import CookieNotice from './CookieNotice'

const useStyles = makeStyles()(() => ({
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

/**
 * Terms and conditions acceptance page component
 */
const TermsAndConditionsPage: React.VFC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const { cookies } = useCookies()
  const cookiesNotAllowed = !cookies.cookieConsent

  return (
    <>
      <Box className={classes.content} p={2}>
        <ReactMarkdown>{t('emobility.vendor-connection-terms-dialog.content')}</ReactMarkdown>
      </Box>
      <Box>
        <FormControlLabel
          control={<Checkbox name={'accepted'} color="primary" />}
          label={t('emobility.vendor-connection-terms-dialog.checkBoxLabel')}
        />
      </Box>
      <Box>{cookiesNotAllowed && <CookieNotice />}</Box>
    </>
  )
}

export default TermsAndConditionsPage
